import React, { useState } from "react";
import {
  Tooltip,
  Box,
  Typography,
  Stack,
  LinearProgress,
  styled,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { palette, theme as colorTheme } from "../../../../Convoze.theme";
import { CardTravelSharp } from "@mui/icons-material";

/* --------------  dummy data  -------------- */
// const dummyLabels = [
//   "connected",
//   "Lead being called",
//   "do not disturb",
//   "callback",
//   "not interested",
//   "language barrier",
//   "wrong number",
//   "exploring the service",
//   "No response",
// ];

// const dummyValues = [45, 56, 55, 76, 34, 87, 23, 12, 67];

// const buildDummyCardDetails = () => ({
//   disposition: {
//     dispositionNames: dummyLabels,
//     dispositionValues: dummyValues,
//   },
//   subDisposition: {},
// });

/* --------------  styled MUI components  -------------- */
const Bar = styled(LinearProgress)(({ theme, barcolor }) => ({
  height: 10,
  borderRadius: 10,
  backgroundColor: "#e0e0e0",
  "& .MuiLinearProgress-bar": {
    borderRadius: 10,
    backgroundColor: barcolor,
  },
}));

const LegendBox = styled(Box)(({ bg }) => ({
  width: 16,
  height: 16,
  borderRadius: 4,
  backgroundColor: bg,
}));

/* --------------  component  -------------- */
const DespositionAnalytics = ({ cardDetails }) => {
  // const safeCardDetails = cardDetails || buildDummyCardDetails();
  const safeCardDetails = cardDetails || {
    disposition: {},
    subDisposition: {},
  };
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const navigate = useNavigate();

  // console.log("Inside Despositin Analytics component",cardDetails)

  const HoverTooltipBox = ({ label, count }) => (
    <Box display="flex" flexDirection="column" gap={0.5} p={0.5}>
      <Typography fontSize={13} color="#555">
        Number of Calls
      </Typography>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Box
          width={10}
          height={10}
          borderRadius="50%"
          bgcolor={colorTheme("palette", "primary").value}
        />
        <Typography fontSize={13} color="#555" fontWeight={600}>
          {label}
        </Typography>
        <Box ml="auto">
          <Typography fontSize={13} fontWeight={900}>
            {count}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );

  function transformDispositionData(rawData) {
    const total = rawData?.dispositionValues?.reduce((s, v) => s + v, 0);
    return rawData?.dispositionNames?.map((name, idx) => ({
      label: name,
      count: rawData.dispositionValues[idx],
      value: ((rawData.dispositionValues[idx] / total) * 100).toFixed(1),
      category: "disposition",
    }));
  }

  function transformSubDispositionData(rawData) {
    const total = rawData?.subDispositionValues?.reduce((s, v) => s + v, 0);
    return rawData?.subDispositionNames?.map((name, idx) => ({
      label: name,
      count: rawData.subDispositionValues[idx],
      value: ((rawData.subDispositionValues[idx] / total) * 100).toFixed(1),
      category: "subDisposition",
    }));
  }

  const transformedSubData = Array.isArray(
    safeCardDetails?.subDisposition?.subDispositionNames
  )
    ? transformSubDispositionData(safeCardDetails.subDisposition)
    : [];

  const transformedData = Array.isArray(
    safeCardDetails?.disposition?.dispositionNames
  )
    ? transformDispositionData(safeCardDetails.disposition)
    : [];

  const combinedArray = [...transformedData, ...transformedSubData];
  const hasData = combinedArray.length > 0;
  // console.log("transformed data", transformedData)
  // console.log("Combined data", combinedArray)

  /* ----------  render  ---------- */
  // return (
  //   <Box
  //     sx={{
  //       flex: 1,
  //       borderRadius: 2,
  //       p: 2,
  //       boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  //       backgroundColor: "#FFFFFF",
  //       height: "50vh",
  //     }}
  //     height="100%"
  //   >
  //     {combinedArray.length > 0 && <Stack
  //         direction="row"
  //         justifyContent="space-between"
  //         alignItems="center"
  //         mb={3.75}
  //       >
  //         <Typography variant="body3" fontWeight={600}>
  //           Disposition Analytics
  //         </Typography>

  //         <Stack direction="row" spacing={2} px={2} flexWrap="wrap">

  //           <Stack direction="row" alignItems="center" spacing={1}>
  //             <LegendBox bg={colorTheme('palette', 'positive').value} />
  //             <Typography fontSize={14}>Disposition</Typography>
  //           </Stack>
  //           <Stack direction="row" alignItems="center" spacing={1}>
  //             <LegendBox bg={colorTheme('palette', 'neutral').value} />
  //             <Typography fontSize={14}>Sub Disposition</Typography>
  //           </Stack>
  //         </Stack>
  //       </Stack>}

  //     {combinedArray.length == 0 ?(
  //       <Stack height="100%" spacing={1}>
  //         <Typography variant="h6" color="#686868" textAlign="left">
  //           {"Disposition Analytics"}
  //         </Typography>
  //         <Box
  //           flex={1}
  //           display="flex"
  //           alignItems="center"
  //           justifyContent="center"
  //           borderRadius={1}
  //           color="#999"
  //           fontSize="1rem"
  //           fontWeight={600}
  //         >
  //           No data available
  //         </Box>
  //       </Stack>
  //     ) : (
  //       <Box
  //         maxHeight={300}
  //         overflow="auto"
  //         pr={2.25}
  //         sx={{
  //           flex: 1,
  //           height: "85%",
  //           overflow: "auto",
  //           "&::-webkit-scrollbar": { width: 4 },
  //           "&::-webkit-scrollbar-track": { bgcolor: "transparent" },
  //           "&::-webkit-scrollbar-thumb": {
  //             bgcolor:colorTheme('palette', 'primary').value,
  //             borderRadius: 4,
  //           },
  //           "&::-webkit-scrollbar-thumb:hover": { bgcolor: colorTheme('palette', 'primary').value },
  //         }}
  //       >
  //         {combinedArray.map((item, idx) => (
  //           <Tooltip
  //             key={idx}
  //             title={<HoverTooltipBox label={item.label} count={item.count} />}
  //             placement="top"
  //             arrow
  //             componentsProps={{
  //               tooltip: { sx: { bgcolor: "#fff", color: "#333", p: 2 } },
  //             }}
  //           >
  //             <Stack
  //               direction="row"
  //               alignItems="center"
  //               spacing={1.5}
  //               mb={2.25}
  //               px={1.25}
  //               py={1.25}
  //               borderRadius={hoveredIndex === idx ? 1 : 0}
  //               bgcolor={hoveredIndex === idx ? "#E6E6E6" : "transparent"}
  //               sx={{ cursor: "pointer", transition: "all 0.3s ease" }}
  //               onMouseEnter={() => setHoveredIndex(idx)}
  //               onMouseLeave={() => setHoveredIndex(null)}
  //               onClick={() =>
  //                 navigate("/user/audio-details", {
  //                   state: {
  //                     label: item.label,
  //                     source:
  //                       item.category === "disposition"
  //                         ? "dashboard-disposition"
  //                         : "dashboard-subDisposition",
  //                   },
  //                 })
  //               }
  //             >
  //               <Typography width={150} fontSize={14} fontWeight={700}>
  //                 {item.label}
  //               </Typography>

  //               <Box flex={1}>
  //                 <Bar
  //                   variant="determinate"
  //                   value={Number(item.value)}
  //                   barcolor={
  //                     item.category === "disposition" ? colorTheme('palette', 'positive').value: colorTheme('palette', 'neutral').value
  //                   }
  //                 />
  //               </Box>

  //               <Typography
  //                 minWidth={50}
  //                 textAlign="right"
  //                 fontSize={14}
  //                 fontWeight={900}
  //               >
  //                 {item.count}
  //               </Typography>
  //             </Stack>
  //           </Tooltip>
  //         ))}
  //       </Box>
  //     )}
  //   </Box>
  // );

  return (
    <Box
      sx={{
        flex: 1,
        borderRadius: 2,
        height: "50vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box width="100%" display="flex" justifyContent="space-between" mb="20px">
        <Typography
          fontSize={14}
          variant="body2"
          color="#464646"
          fontWeight={700}
        >
          Disposition Analytics
        </Typography>

        {combinedArray.length > 0 && (
          <Stack direction="row" spacing={2} px={2} flexWrap="wrap">
            <Stack direction="row" alignItems="center" spacing={1}>
              <LegendBox bg={colorTheme("palette", "positive").value} />
              <Typography fontSize={14}>Disposition</Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={1}>
              <LegendBox bg={colorTheme("palette", "neutral").value} />
              <Typography fontSize={14}>Sub Disposition</Typography>
            </Stack>
          </Stack>
        )}
      </Box>

      {/* ---------- content ---------- */}
      {combinedArray?.length === 0 ? (
        <Box
          flex={1}
          display="flex"
          alignItems="center"
          justifyContent="center"
          fontSize="1rem"
          fontWeight={600}
          color="#999"
          borderRadius="8px"
        >
          No data available
        </Box>
      ) : (
        <Box
          flex={1}
          overflow="auto"
          pr="18px"
          sx={{
            "&::-webkit-scrollbar": { width: 4 },
            "&::-webkit-scrollbar-track": { bgcolor: "transparent" },
            "&::-webkit-scrollbar-thumb": {
              bgcolor: "#C1C7CE",
              borderRadius: 4,
            },
            "&::-webkit-scrollbar-thumb:hover": {
              bgcolor: "#C1C7CE",
            },
          }}
        >
          {combinedArray?.map((item, idx) => (
            <Tooltip
              key={idx}
              title={<HoverTooltipBox label={item.label} count={item.count} />}
              placement="top"
              arrow
              componentsProps={{
                tooltip: { sx: { bgcolor: "#fff", color: "#333", p: 2 } },
              }}
            >
              <Stack
                direction="row"
                alignItems="center"
                spacing={1.5}
                mb={2.25}
                px={1.25}
                py={1.25}
                borderRadius={hoveredIndex === idx ? 1 : 0}
                bgcolor={hoveredIndex === idx ? "#E6E6E6" : "transparent"}
                sx={{ cursor: "pointer", transition: "all 0.3s ease" }}
                onMouseEnter={() => setHoveredIndex(idx)}
                onMouseLeave={() => setHoveredIndex(null)}
                onClick={() =>
                  navigate("/user/audio-details", {
                    state: {
                      label: item.label,
                      source:
                        item.category === "disposition"
                          ? "dashboard-disposition"
                          : "dashboard-subDisposition",
                    },
                  })
                }
              >
                <Typography width={150} fontSize={14} fontWeight={700}>
                  {item.label}
                </Typography>

                <Box flex={1}>
                  <Bar
                    variant="determinate"
                    value={Number(item.value)}
                    barcolor={
                      item.category === "disposition"
                        ? colorTheme("palette", "positive").value
                        : colorTheme("palette", "neutral").value
                    }
                  />
                </Box>

                <Typography
                  minWidth={50}
                  textAlign="right"
                  fontSize={14}
                  fontWeight={900}
                >
                  {item.count}
                </Typography>
              </Stack>
            </Tooltip>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default DespositionAnalytics;
